import { useState } from 'react';
import {
    Sidebar, Menu, MenuItem, SubMenu
} from 'react-pro-sidebar';
import { FaUsers, FaPaperPlane, FaFolderTree, FaNewspaper, FaArrowsRotate, FaReadme, FaCashRegister, FaRegistered, FaDiamondTurnRight, FaArrowUpRightDots, FaChartLine, FaCircleDollarToSlot, FaClipboardList, FaChartSimple, FaChalkboardUser, FaReceipt, FaArrowTrendUp, FaCloudArrowDown, FaRebel } from "react-icons/fa6";
import {
    FaSignOutAlt, FaFolderOpen, FaHome, FaRegPaperPlane, FaDatabase, FaBook, FaArchive, FaLock, FaUser, FaAdjust, FaAtom,
    FaCogs, FaEyeDropper, FaEyeSlash, FaRegEye, FaEye, FaSms, FaCity, FaExchangeAlt, FaUserCircle, FaKey,
    FaQuestion,
    FaDollarSign,
    FaSearch,
    FaFileExcel,
    FaRegBell
} from "react-icons/fa";
import { MdTimeline, MdOutlineAvTimer, MdOutlineFeaturedPlayList } from "react-icons/md";
import { Link, useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchRoles, logout } from '../store/authSlice';
import { useInfoUser, usePermission } from '../helper/authHelper';
import { TbChartInfographic } from "react-icons/tb";



function SideBarPro({ AdminTae }) {
    const [collapse, SetCollapse] = useState(true);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { User, Company, Admin, CompanyId } = useInfoUser();
    const inicialLogin = String(User).substring(0, 1).toUpperCase();

    const { GestionEmpresa, SeguridadUsuarios, SeguridadRoles, GestionModPlanes, SeguridadAuditoria,
        GestionReportes, GestionEnvios, GestionRadian, GestionRepIns, GestionRepCer, GestionRepPla, GestionRepTiem,
        GestionEnvFac, GestionEnvNom, GestionSeguridad, GestionRepEmis, GestionConfig, GestionPlantilla,
        GestionBandejaEnviado, GestionSMTP, GestionModuloTrans, GestionReporCliente, GestionRepProye
    } = usePermission([
        "GestionEmpresa",
        "SeguridadUsuarios",
        "SeguridadRoles",
        "GestionModPlanes",
        "SeguridadAuditoria",
        "GestionReportes",
        "GestionEnvios",
        "GestionRadian",
        "GestionRepIns",
        "GestionRepCer",
        "GestionRepPla",
        "GestionRepTiem",
        "GestionEnvFac",
        "GestionEnvNom",
        "GestionSeguridad",
        "GestionRepEmis",
        "GestionConfig",
        "GestionPlantilla",
        "GestionBandejaEnviado",
        "GestionSMTP",
        "GestionModuloTrans",
        "GestionReporCliente",
        "GestionRepProye"
    ]);

    const location = useLocation();
    const ocultarEn = ["/Seguridad/ConfirmaBaja"];
    const mostrarMenu = !ocultarEn.some(ruta => location.pathname.startsWith(ruta));

    //Función para ocultar el menú cuando presione en las opciones con link de los menús o submenús
    const handleClick = (tipo) => {
        SetCollapse(tipo);
    }

    return (
        <>
            {mostrarMenu ? <Sidebar
                backgroundColor='#224B6A'
                collapsed={collapse}
            >
                <div className='text-center mt-1 mb-1'>
                    <div style={{ cursor: 'pointer' }} onClick={() => {
                        SetCollapse(!collapse);
                    }}>
                        <img
                            alt=""
                            src={"/tav-cabeza.gif"}
                            style={{ maxWidth: '70px' }}
                            className="d-inline-block align-top"
                        />
                    </div>
                    {collapse === false ?
                        <img
                            alt=""
                            src="/TAE-COL BLANCO.png"
                            style={{ maxWidth: '160px' }}
                            className="d-inline-block align-top"
                        /> :
                        null}

                </div>
                <Menu
                    menuItemStyles={{

                        button: ({ level, active, disabled }) => {
                            // only apply styles on first level elements of the tree

                            return {
                                color: disabled ? '#90CBD8' : '#90CBD8',
                                backgroundColor: active ? '#CEF9EA' : undefined,
                                ':hover': { backgroundColor: '#4C799A' },
                                fontSize: "14px"
                            };
                        },
                    }}
                >
                    {AdminTae === true ?
                        <MenuItem
                            title='Inicio'
                            icon={<FaHome size={'2rem'} />}
                            component={<Link to={'/Home'} />}
                            onClick={() => handleClick(true)} >
                            INICIO
                        </MenuItem>
                        :
                        <>
                            <MenuItem
                                title='Inicio'
                                icon={<FaHome size={'2rem'} />}
                                component={<Link to={'/Home/Cliente'} />}
                                onClick={() => handleClick(true)} >
                                INICIO
                            </MenuItem>

                            {Admin !== "true" && GestionEmpresa ?
                                <MenuItem
                                    title='EMPRESA'
                                    icon={<FaCity size={'2rem'} />}
                                    component={<Link to={'/Home/Empresa/Config/' + CompanyId} />}
                                    onClick={() => handleClick(true)} >
                                    EMPRESA
                                </MenuItem> : null}
                        </>
                    }
                    {AdminTae === true ?
                        <>
                            {GestionEmpresa || GestionModPlanes ?
                                <SubMenu
                                    title='EMPRESAS'
                                    icon={<FaCity size={'2rem'} />}
                                    label='EMPRESAS'
                                >
                                    {GestionEmpresa ? <MenuItem
                                        title='Empresas'
                                        icon={<FaUsers size={'2rem'} />}
                                        component={<Link to={'/Home/Empresa'} />}
                                        onClick={() => handleClick(true)}
                                    >
                                        Terceros
                                    </MenuItem> : null}

                                    {GestionModPlanes ? <MenuItem
                                        title='Planes'
                                        icon={<FaFolderOpen size={'2rem'} />}
                                        component={<Link to={'/Home/Plan'} />}
                                        onClick={() => handleClick(true)}
                                    >
                                        Planes
                                    </MenuItem>
                                        : null}
                                </SubMenu>
                                : null}

                            {GestionModuloTrans ?
                                <SubMenu
                                    title='TRANSACCIONES'
                                    icon={<FaCashRegister size={'2rem'} />}
                                    label='TRANSACCIONES'
                                >
                                    <MenuItem
                                        title='Productos'
                                        icon={<FaReceipt size={'2rem'} />}
                                        component={<Link to={'/Home/Productos'} />}
                                        onClick={() => handleClick(true)}
                                    >
                                        Productos
                                    </MenuItem>

                                    <MenuItem
                                        title='Facturas'
                                        icon={<FaBook size={'2rem'} />}
                                        component={<Link to={'/Home/Factura'} />}
                                        onClick={() => handleClick(true)}
                                    >
                                        Facturas
                                    </MenuItem>

                                    <MenuItem
                                        title='Recibos'
                                        icon={<FaCircleDollarToSlot size={'2rem'} />}
                                        component={<Link to={'/Home/Recibos'} />}
                                        onClick={() => handleClick(true)}
                                    >
                                        Recibos
                                    </MenuItem>

                                    <MenuItem
                                        title='Cartera'
                                        icon={<FaChartLine size={'2rem'} />}
                                        component={<Link to={'/Home/Cartera'} />}
                                        onClick={() => handleClick(true)}
                                    >
                                        Cartera
                                    </MenuItem>
                                    <MenuItem
                                        title='Novedades'
                                        icon={<FaRegBell size={'2rem'} />}
                                        component={<Link to={'/Home/Novedades'} />}
                                        onClick={() => handleClick(true)}
                                    >
                                        Gestión novedades
                                    </MenuItem>
                                </SubMenu>
                                : null}

                            {GestionReportes ?
                                <SubMenu
                                    title='REPORTES ADMIN'
                                    icon={<FaNewspaper size={'2rem'} />}
                                    label='REPORTES ADMIN'

                                >
                                    {GestionRepProye ?
                                        <MenuItem
                                            title='Proyección ventas'
                                            icon={<FaArrowTrendUp size={'2rem'} />}
                                            component={<Link to={'/Home/Reporte/ProyeccionVentas'} />}
                                            onClick={() => handleClick(true)}
                                        >
                                            Proyección
                                        </MenuItem> : null
                                    }

                                    {GestionRepIns ?
                                        <MenuItem
                                            title='Instancia'
                                            icon={<FaNewspaper size={'2rem'} />}
                                            component={<Link to={'/Home/Reporte/EmisionInstancia'} />}
                                            onClick={() => handleClick(true)}
                                        >
                                            Instancias
                                        </MenuItem>
                                        : null}
                                    {GestionRepEmis ?
                                        <MenuItem
                                            title='Emisiones General'
                                            icon={<TbChartInfographic size={'2rem'} />}
                                            component={<Link to={'/Home/Reporte/EmisionDashboard'} />}
                                            onClick={() => handleClick(true)}
                                        >
                                            Emisiones
                                        </MenuItem>
                                        : null}


                                    {GestionRepCer ? <MenuItem
                                        title='Instancia'
                                        icon={<MdOutlineFeaturedPlayList size={'2rem'} />}
                                        component={<Link to={'/Home/Reporte/Certificados'} />}
                                        onClick={() => handleClick(true)}
                                    >
                                        Certificados
                                    </MenuItem> : null}

                                    {GestionRepPla ?
                                        <MenuItem
                                            title='Planes'
                                            icon={<MdTimeline size={'2rem'} />}
                                            component={<Link to={'/Home/Reporte/EmisionPlan'} />}
                                            onClick={() => handleClick(true)}
                                        >
                                            Planes
                                        </MenuItem>
                                        : null}

                                    {GestionRepTiem ?
                                        <MenuItem
                                            title='Tiempos'
                                            icon={<MdOutlineAvTimer size={'2rem'} />}
                                            component={<Link to={'/Home/Reporte/EmisionTiempo'} />}
                                            onClick={() => handleClick(true)}
                                        >
                                            Tiempos
                                        </MenuItem>
                                        : null}

                                </SubMenu>
                                : null}
                        </>
                        :
                        null
                    }

                    {GestionReporCliente ?
                        <SubMenu
                            title={'REPORTES' + (AdminTae === true ? ' CLIENTES' : '')}
                            icon={<FaChalkboardUser size={'2rem'} />}
                            label={'REPORTES' + (AdminTae === true ? ' CLIENTES' : '')}
                        >
                            <MenuItem
                                title='Documentos'
                                icon={<FaNewspaper size={'2rem'} />}
                                component={<Link to={'/Cliente/ReporteEmisionDocumentos'} />}
                                onClick={() => handleClick(true)}
                            >
                                Categorías
                            </MenuItem>
                            <MenuItem
                                title='Documentos'
                                icon={<FaChartSimple size={'2rem'} />}
                                component={<Link to={'/Cliente/ReporteEmisionPrefijos'} />}
                                onClick={() => handleClick(true)}
                            >
                                Documentos
                            </MenuItem>
                            <MenuItem
                                title='General'
                                icon={<FaFileExcel size={'2rem'} />}
                                component={<Link to={'/Cliente/ReporteEmisionGeneralExcel'} />}
                                onClick={() => handleClick(true)}
                            >
                                General
                            </MenuItem>
                        </SubMenu>
                        : null}


                    {AdminTae === true ?
                        <>
                            {GestionEnvios ?
                                <SubMenu
                                    title='ENVIOS'
                                    icon={<FaPaperPlane size={'2rem'} />}
                                    label='ENVIOS'

                                >
                                    {GestionEnvFac ?
                                        <MenuItem
                                            title='Envios Electronicos'
                                            icon={<FaPaperPlane size={'2rem'} />}
                                            component={<Link to={'/Cliente/DocumentoEnvio'} />}
                                            onClick={() => handleClick(true)}
                                        >
                                            Facturas
                                        </MenuItem> : null}

                                    {GestionEnvNom ?
                                        <MenuItem
                                            title='Envios Nominas'
                                            icon={<FaRegPaperPlane size={'2rem'} />}
                                            component={<Link to={'/Cliente/NominaEnvio'} />}
                                            onClick={() => handleClick(true)}
                                        >
                                            Nomina
                                        </MenuItem> : null}
                                </SubMenu>
                                : null}

                            {GestionRadian ?
                                <MenuItem
                                    title='RADIAN'
                                    icon={<FaFolderTree size={'2rem'} />}
                                    component={<Link to={'/Cliente/RadianIndex'} />}
                                >
                                    RADIAN
                                </MenuItem>

                                // <SubMenu
                                //     title='RADIAN'
                                //     icon={<FaFolderTree size={'2rem'} />}
                                //     label='RADIAN'
                                // >

                                //     <MenuItem
                                //         title='Radian'
                                //         icon={<FaFolderTree size={'2rem'} />}
                                //         component={<Link to={'/Cliente/RadianIndex'} />}
                                //     >
                                //         Radian manual
                                //     </MenuItem>
                                //     <MenuItem
                                //         title='Radian'
                                //         icon={<FaCloudArrowDown size={'2rem'} />}
                                //         component={<Link to={'/Cliente/RadianIndexV2'} />}
                                //     >
                                //         Radian automatico
                                //     </MenuItem>
                                // </SubMenu> 

                                : null}

                            {GestionConfig ?
                                <SubMenu
                                    title='ADMINISTRACION'
                                    icon={<FaCogs size={'2rem'} />}
                                    label='ADMINISTRACION'
                                >
                                    {GestionPlantilla ?
                                        <MenuItem
                                            title='Plantilla de correos'
                                            icon={<FaReadme size={'2rem'} />}
                                            component={<Link to={'/Configuracion/PlantillasCorreos'} />}
                                            onClick={() => handleClick(true)}
                                        >
                                            Plantillas
                                        </MenuItem>
                                        : null}

                                    {GestionSMTP ?
                                        <MenuItem
                                            title='SMTP'
                                            icon={<FaDatabase size={'2rem'} />}
                                            component={<Link to={'/Configuracion/Smtp'} />}
                                            onClick={() => handleClick(true)}
                                        >
                                            Smtp
                                        </MenuItem>
                                        : null}

                                    {GestionBandejaEnviado ?
                                        <MenuItem
                                            title='SMTP'
                                            icon={<FaPaperPlane size={'2rem'} />}
                                            component={<Link to={'/Configuracion/BandejaEnviados'} />}
                                            onClick={() => handleClick(true)}
                                        >
                                            Enviados
                                        </MenuItem>
                                        : null}

                                </SubMenu>
                                : null}


                        </>
                        :
                        <>
                            <SubMenu
                                title='ENVIOS'
                                icon={<FaPaperPlane size={'2rem'} />}
                                label='ENVIOS'

                            >

                                <MenuItem
                                    title='Envios Electronicos'
                                    icon={<FaPaperPlane size={'2rem'} />}
                                    component={<Link to={'/Cliente/DocumentoEnvio'} />}
                                    onClick={() => handleClick(true)}
                                >
                                    Facturas
                                </MenuItem>
                                <MenuItem
                                    title='Envios Nominas'
                                    icon={<FaRegPaperPlane size={'2rem'} />}
                                    component={<Link to={'/Cliente/NominaEnvio'} />}
                                    onClick={() => handleClick(true)}
                                >
                                    Nomina
                                </MenuItem>

                            </SubMenu>

                            <MenuItem
                                title='RADIAN'
                                icon={<FaFolderTree size={'2rem'} />}
                                component={<Link to={'/Cliente/RadianIndex'} />}
                            >
                                RADIAN
                            </MenuItem>

                            {/* <SubMenu
                                title='RADIAN'
                                icon={<FaFolderTree size={'2rem'} />}
                                label='RADIAN'
                            >

                                <MenuItem
                                    title='Radian'
                                    icon={<FaFolderTree size={'2rem'} />}
                                    component={<Link to={'/Cliente/RadianIndex'} />}
                                >
                                    Radian manual
                                </MenuItem>
                                <MenuItem
                                    title='Radian'
                                    icon={<FaCloudArrowDown size={'2rem'} />}
                                    component={<Link to={'/Cliente/RadianIndexV2'} />}
                                >
                                    Radian automatico
                                </MenuItem>
                            </SubMenu> */}
                        </>
                    }

                    {GestionSeguridad ?
                        <SubMenu
                            title='SEGURIDAD'
                            icon={<FaLock size={'2rem'} />}
                            label='SEGURIDAD'
                        >
                            {SeguridadUsuarios ? <MenuItem
                                title='Usuarios'
                                icon={<FaUsers size={'2rem'} />}
                                component={<Link to={'/Seguridad/Usuarios'} />}
                                onClick={() => handleClick(true)}
                            >
                                Usuarios
                            </MenuItem> : null}

                            {SeguridadRoles ? <MenuItem
                                title='Roles'
                                icon={<FaBook size={'2rem'} />}
                                component={<Link to={'/Seguridad/Roles'} />}
                                onClick={() => handleClick(true)}
                            >
                                Roles
                            </MenuItem> : null}

                            {SeguridadAuditoria ? <MenuItem
                                title='Auditoría'
                                icon={<FaEye size={'2rem'} />}
                                component={<Link to={'/Seguridad/Auditoria'} />}
                                onClick={() => handleClick(true)}
                            >
                                Auditoría
                            </MenuItem> : null}

                            <MenuItem
                                title='Act. permisos'
                                icon={<FaArrowsRotate size={'2rem'} />}
                                onClick={() => {
                                    dispatch(fetchRoles())
                                        .unwrap() ///Si el tunk falla entra directo al catch
                                        .then(() => {
                                            window.location.reload(); ///Cuando se guardan de manera correcta procede a refrescar la pagina
                                        })
                                        .catch((err) => {
                                            console.log(err);
                                        })
                                }}
                            >
                                Act. permisos
                            </MenuItem>

                        </SubMenu>
                        : null}

                    {/* <MenuItem
                        title='Cerrar sesion'
                        icon={<FaSignOutAlt size={'2rem'} />}
                        onClick={() => {
                            localStorage.clear();
                            navigate('/');
                            window.location.reload();
                            dispatch(logout());
                        }}
                    >
                        CERRAR SESIÓN
                    </MenuItem> */}

                    {/* {!collapse ?
                        <> */}
                    <SubMenu
                        title={User}
                        icon={<FaUserCircle size={'2rem'} />}
                        label={User}
                    >
                        <MenuItem
                            title='Novedades'
                            icon={<FaNewspaper size={'2rem'} />}
                            component={<Link to={'/Cliente/NovedadVisualiza'} />}
                            onClick={() => handleClick(true)}
                        >
                            Novedades
                        </MenuItem>
                        <MenuItem
                            title='Soporte'
                            icon={<FaQuestion size={'2rem'} />}
                            component={<Link to={'/Home/Pqr'} />}
                            onClick={() => handleClick(true)}
                        >
                            PQR
                        </MenuItem>
                        {/* {AdminTae !== true ?
                            <MenuItem
                                title='AutoGestión'
                                icon={<FaDollarSign size={'2rem'} />}
                                component={<Link to={'/Home/AutoGestion'} />}
                                onClick={() => handleClick(true)}
                            >
                                Renovación
                            </MenuItem>
                            : <MenuItem
                                title='Gestión clientes'
                                icon={<FaSearch size={'2rem'} />}
                                component={<Link to={'/Home/GestionClientes'} />}
                                onClick={() => handleClick(true)}
                            >
                                Gestión clientes
                            </MenuItem>} */}
                        <MenuItem
                            icon={<FaKey size={'2rem'} />}
                            onClick={() => {
                                navigate('/Login/GestionarClave/yy');
                                window.location.reload();
                            }}>Cambiar clave</MenuItem>
                        <MenuItem
                            title='Cerrar sesion'
                            icon={<FaSignOutAlt size={'2rem'} />}
                            onClick={() => {
                                localStorage.clear();
                                navigate('/');
                                window.location.reload();
                                dispatch(logout());
                            }}
                        >
                            Cerrar sesión
                        </MenuItem>
                    </SubMenu>
                    {!collapse ?
                        <>
                            {/* <div style={{
                                marginTop: 'auto',
                                padding: '10px',
                                fontSize: '12px',
                                textAlign: 'center',
                                color: '#90CBD8'
                            }}>
                                {User}
                            </div> */}
                            <div style={{
                                marginTop: 'auto',
                                fontSize: '12px',
                                textAlign: 'center',
                                color: '#90CBD8'
                            }}>
                                {Company}
                            </div>
                        </>
                        : null}
                    {/* </>
                        : null} */}
                </Menu>
            </Sidebar >
                : null}

            {/*Vista que me permite tener un menú flotanto en la parte superior derecha para gestionar el cerrar sersión y de mas información basica de la empresa */}
            {/* <MenuFlotante user={inicialLogin} /> */}
        </>
    );
}

export default SideBarPro